global.jQuery = require('jquery');
require('bootstrap/js/tooltip');
var _ = require('underscore');
var Marionette = require('backbone.marionette');

// Adds bootstrap tooltips on view:show and destroys them on view:destroy
// Options:
// -container: tooltip container. can either be a string or a function executed in the context of the view. defaults to view.$el

var Tooltips = Marionette.Behavior.extend({
    defaults: {
        container: function() {
            return this.$el;
        },
    },
    ui: {
        tooltips: '[data-toggle="tooltip"]',
    },
    onRender: function() {
        var container = this.options.container;
        container = _.isFunction(container) ? container.call(this.view) : container;
        this.ui.tooltips.tooltip({
            container: container,
        });
    },
    onBeforeDestroy: function() {
        this.ui.tooltips.tooltip('destroy');
    },
});

module.exports = Tooltips;
